import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Idiomas1Component } from  './idiomas1.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTreeModule} from '@angular/material/tree';

@NgModule({
  declarations: [
  Idiomas1Component],
  imports: [
    CommonModule,
    MatTabsModule,
    MatTreeModule
    

  ]
})
export class Idiomas1Module { }
